export const EVENT = {
  CURRENTTIME_CHANGE: "setcurrenttime",   // 当前时间改变
  LOOP_CHANGE: "loopchange", // 循环状态改变
  MUTE_CHANGE: "mutedchange",   // 静音状态改变
  RATE_CHANGE: "ratechange",   // 倍速改变
  VOLUME_CHANGE: "volumechange", // 音量改变
  FULLSCREEN_CHANGE: "fullscreenchanged", // 全屏状态改变
  DEFINITION_CHANGE: "definitionchange", // 当前清晰度变化
  LAG_REPORT: "lagreport", // 卡顿
  LAG_RECOVER: "lagrecover", // 卡顿恢复
  PLAY: "play", // 播放
  PAUSE: "pause", // 暂停
  PROGRESS: "progress", // 视频加载中
  LOADED: "loadedmetadata", // 视频加载完成
  ERROR: "error", // 播放器出错
  ENDED: "ended", // 播放完毕
  OPEN_BARRAGE: "openbarrage", // 开启弹幕
  CLOSE_BARRAGE: "closebarrage", // 关闭弹幕
  CLEAR_BARRAGE: "clearbarrage", // 清空弹幕
  TIMEUPDATE: "timeupdate"  // 时间改变事件
}

export const API_URL = {
  /** 获取token接口 */
  INIT: '/init/start',
  INIT_LIVE: '/room/get-watch-info', //直播观看初始化
  INIT_VOD: '/demand/get-record-watch-info',//点播观看初始化
}

export const KV = {
  APP_ID: "app_id",
  THIRD_PARTY_USER_ID: "third_party_user_id",
  CLIENT: 'client',
  ACCESS_TOKEN: 'access_token',
  PACKAGE_CHECK:'package_check',
}